module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'danger'
    },
    on: {
      "click": function($event) {
        _vm.resetJobDetails()
      }
    }
  }, [_vm._v("\n    Reset Sline Flow\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45302ea2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/ResetSlineSubscription.vue
// module id = 2569
// module chunks = 0